import initialstate from '../../initialstate';
import * as types from '../../../actions/actiontypes';
import { workSpaceStatusEnum } from '../../../util/uiconstants';
import env from '../../../util/env';
import moment from 'moment';
import { currentResource } from '../../../util/uiconstants';

export function dataCenterDetailsReducer(state = initialstate.dataCentersSharepointWorkspaces, action) {
	switch (action.type) {
		case types.GET_ALL_DAAS_WORKSPACES:
			return formatDatacenterDetails(action.response);
		default:
			return state;
	}
}

export function workSpaceDetailsReducer(state = initialstate.workSpaceDetails, action) {
	switch (action.type) {
		case types.GET_ALL_DAAS_WORKSPACES_DETAILS:
			return formatWorkSpacesDetails(action.response ?? {});
		default:
			return state;
	}
}

const formatWorkSpacesCount = (collaborationWorkspaces) => {
	let count = collaborationWorkspaces.length;
	return count > 0 ? `${count}` : '-';
};

const formatDatacenterDetails = (data) => {
	data = Array.isArray(data) ? data : [];
	data = data.map(x => {
		return {
			dataCenterId: x.dataCenterId,
			dataCenterCountryId: x.dataCenterCountryId,
			dataCenterName: x.dataCenterName,
			workspacesCount: formatWorkSpacesCount(x.collaborationWorkspaces ?? []),
			pendingWorkspacesCount: formatWorkSpacesCount(
				x.collaborationWorkspaces?.filter(x => x.collaborationWorkspaceStatusID === workSpaceStatusEnum.PENDING) ?? []),
		}
	});

	return data;
};

const formatWorkSpacesDetails = (workspaceObject) => {
	let workspaceList = workspaceObject.collaborationWorkspaces ?? [];

	workspaceList = workspaceList.map(x => {
		return {
			workspaceId: x.collaborationWorkspaceID,
			workspaceName: x.collaborationWorkspaceName,
			documentCount: x.libraryCount,
			consumedCapacityPercentage: x.libraryCount !== null ?
				Math.round((x.libraryCount / env.getSharePointWorkspaceCapacity()) * 100) : null,
			statusId: x.collaborationWorkspaceStatusID,
			status: currentResource.workspaceStatusLabels[x.collaborationWorkspaceStatusID],
			statusChangeDate: moment(x.modifyDate ?? x.createDate).format('MM-DD-YYYY'),
		}
	});

	workspaceObject = {
		...workspaceObject,
		collaborationWorkspaces: workspaceList
	};

	return workspaceObject;
}